/* @ngInject */
function authConfig($httpProvider) {
  $httpProvider.interceptors.push('AuthInterceptor');
}

export default authConfig;



// WEBPACK FOOTER //
// ./client/components/auth/auth.config.js